/* Entries a member holds in a draw that has closed to entries but not yet been
 * spun — a draw closes at 10 pm Friday and may be spun days later (a postponed
 * draw). They stay the member's until the spin, so the tiles say so beside this
 * week's count instead of showing a sudden zero. */
export type PendingDrawEntries = { endDate: string; entries: number };

const closedOn = (iso: string) =>
  new Intl.DateTimeFormat('en-AU', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    timeZone: 'Australia/Melbourne'
  }).format(new Date(iso));

/** "+1 in the draw closed Fri 9 Oct · still to be drawn", or null when nothing waits. */
export const pendingDrawsLine = (
  pending: PendingDrawEntries[] | null | undefined
): string | null => {
  const waiting = (pending || []).filter((p) => Number(p.entries) > 0);
  if (!waiting.length) return null;
  const parts = waiting.map(
    (p) =>
      `+${Number(p.entries).toLocaleString('en-AU')} in the draw closed ${closedOn(
        p.endDate
      )}`
  );
  return `${parts.join(' · ')} · still to be drawn`;
};
